export default __webpack_public_path__ + "static/content2-fb8469a6f626d0a9b604c9397feb625a.jpg";